import React, { useState ,useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { fetchApp } from '../../store/actions/appAction'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Typography, Grid, Box, Button, Chip } from '@material-ui/core';
import CircleIcon from '@mui/icons-material/Circle';
import Moment from "moment"

const useStyles = makeStyles((theme) => ({
  tableRoot: {
    position: 'relative',
    "& .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:nth-child(4) .MuiChip-root": {
      border: 'none'
    },
    "& .MuiTypography-root": {
      position: 'absolute',
      bottom: '18px',
      left: '15px'
    }
  },
  date : {
    fontSize: '12px',
    color: '#ababab',
    position: 'absolute', 
    bottom: '15px', 
    left: '15px',

    [theme.breakpoints.down("sm")]: {
      bottom: '-25px !important', 
      right: '0 !important',
      left: '0',
      textAlign: 'center'
    },
  }
}));

const columns = [
  { 
    id: 'name', 
    label: 'Nama User', 
    minWidth: 170 
  },
  { 
    id: 'date', 
    label: 'Tanggal/Waktu', 
    minWidth: 170,
    align: 'center', 
    type: "dateTime",
  },
  {
    id: 'login',
    label: 'Login via',
    minWidth: 170,
    align: 'center'
  },
  {
    id: 'status',
    label: 'Status',
    minWidth: 100,
    align: 'center'
  },
];


const ReportTable = ({ recentSignIn }) => {
  const dispatch = useDispatch()
  const classes = useStyles();
  const {id} = useParams()
  useEffect(() => {
    dispatch(fetchApp(id))
  }, [dispatch, id])
    
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    const rowsData = []
    recentSignIn?.forEach(data => {
      switch (data.category) {
        case 'googleLogin':
          data.category = 'Google'
          break;
        case 'facebookLogin':
          data.category = 'Facebook'
          break;
        case 'linkedInLogin':
          data.category = 'LinkedIn'
          break;
        case 'smsOTP':
          data.category = 'SMS OTP'
          break;
        case 'waOTP':
          data.category = 'Whatsapp OTP'
          break;
        default:
          break;
      }
      const dt = Moment(data.timestamp).format('DD MMMM YYYY')
      const tm = Moment(data.timestamp).format('HH:mm')
      const tz = new Date(data.timestamp).getTimezoneOffset() < 0 ?
                  `+${-(new Date(data.timestamp).getTimezoneOffset()/60)}`
                  :
                  `-${-(new Date(data.timestamp).getTimezoneOffset()/60)}`
      data.timestamp = `${dt} | ${tm} (GMT ${tz})`
      if (data.status === 'success') {
        rowsData.push({
          id: data._id,
          name: data.customerName,
          date: data.timestamp,
          login: data.category,
          status: <Chip icon={<CircleIcon className='font-size-10 text-green' />} label="Berhasil" variant="outlined" />  
        })      
      } else {
        rowsData.push({
          id: data._id,
          name: data.customerName,
          date: data.timestamp,
          login: data.category,
          status: <Chip icon={<CircleIcon className='font-size-10 text-red' />} label="Gagal" variant="outlined" />
        })      
      }
    })
    setRows(rowsData)  
  }, [recentSignIn])

  return (
    <Grid container style={{position: 'relative'}}>
      <Box className="d-flex mb-15 w-100" style={{ justifyContent: 'space-between' }}>
        <Typography className="font-size-18 bold">
          Data Login Terakhir
        </Typography>
        <Button
        variant="contained"
        color="secondary"
        className="btn-black text-transform-unset"
        style={{padding: "5px 10px"}}
        >
        Export
        </Button>
      </Box>
      <Paper sx={{ width: '100%', overflow: 'hidden' }} className={classes.tableRoot}>
        <TableContainer sx={{ maxHeight: 380 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>
                  Name User
                </TableCell>
                <TableCell align="center">
                  Tanggal/Waktu
                </TableCell>
                <TableCell align="center" >
                  Login Via
                </TableCell>
                <TableCell align="center">
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody stripedRows >
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === 'number'
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Grid>
  );
}

export default ReportTable
